import React from "react";
import { CtaButton } from "../CtaButton";
import { caseSteps } from "../../data/content";
export function CaseExample() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-147" data-mp="1da2cevb1nsh2">
      <div className="mx-auto max-w-3xl" data-id="element-148" data-mp="1i83xfls161v6">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-plum-950 sm:text-4xl" data-id="element-149" data-mp="1i72n5jiu9jei">
          See How the Pediatric Feeding Decision Pathway™ Works in Practice
        </h2>
        <p className="mt-3 text-center font-display text-lg font-extrabold text-plum-600" data-id="element-150" data-mp="1r0pduv86vwgu">
          One Case. Six Organized Steps. A Documented Planning Workflow.
        </p>

        <div className="mt-8 rounded-2xl border-l-4 border-mint-500 bg-mint-50 p-5 text-base leading-relaxed text-slate-700" data-id="element-151" data-mp="210g8qy0nwdhg">
          Imagine you’re reviewing a pediatric feeding referral. The caregiver reports a restricted food repertoire,
          difficulty participating in family meals, and concerns about certain food textures. You have multiple pieces of
          information, but they haven’t yet been organized into a complete clinical picture.
        </div>

        <ol className="mt-8 space-y-4" data-id="element-152" data-mp="mpd6qcbaqtqb">
          {caseSteps.map((s, i) => <li key={s.title} className="flex gap-4" data-id="element-153" data-mp="hqs8ujjiom51" data-mpi={i}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-plum-700 font-display text-lg font-extrabold text-white" data-id="element-154" data-mp="hrbotuplx0gf">
                {i + 1}
              </span>
              <div className="flex-1 border-b border-plum-100 pb-4" data-id="element-155" data-mp="1aext756ns94c">
                <h3 className="font-display text-lg font-extrabold text-plum-950" data-id="element-156" data-mp="15g3cc8s94umv">{s.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-slate-700" data-id="element-157" data-mp="10giddyd30ma5">{s.text}</p>
                <p className="mt-2 text-sm font-bold text-mint-700" data-id="element-158" data-mp="wg7wvrrnydh1">Result: {s.result}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-8 rounded-3xl bg-plum-900 p-6 text-center text-white" data-id="element-159" data-mp="3l8txg4d7ebhw">
          <p className="font-display text-2xl font-extrabold text-sun" data-id="element-160" data-mp="3h4cdo56ufy74">The Difference?</p>
          <p className="mt-2 text-base leading-relaxed text-plum-100" data-id="element-161" data-mp="3ioe1k3jzi3t0">
            Instead of repeatedly deciding how to organize each part of the case, you have a reusable framework for
            documentation and planning.
          </p>
          <p className="mt-3 font-bold" data-id="element-162" data-mp="38r9bvtqxjq7g">You still make the clinical decisions. The Blueprint helps organize the information supporting those decisions.</p>
        </div>

        <div className="mt-8" data-id="element-163" data-mp="2zv0eslqfd3oh">
          <CtaButton label="Build My Structured Feeding Workflow — $27" data-id="element-164" data-mp="2zuqlao668ee1" />
        </div>
      </div>
    </section>;
}